<template>
  <form class="responsiveTabs" @submit.prevent="submitForm">
    <div class="tabs_content" :disabled="disabled">
      <slot />
    </div>
  </form>
</template>

<script>
export default {
  name: 'app-settings',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submitForm(event) {
      this.$emit('submit', event)
    }
  }
}
</script>
